import reduxMount from './../../jsCore/utils/reduxMounter'
import { MOUNT_POINTS } from './../../jsCore/config/preRenderedSelectorsConfig'
import { MessageUserContainer } from './MessageUser.container'

const COMPONENT_NAME = 'messageUser'
const STATE_KEY = 'messageUser'

export const init = () =>
  reduxMount({
    [MOUNT_POINTS.MESSAGE_USER]: MessageUserContainer({
      componentName: COMPONENT_NAME,
      stateKey: STATE_KEY,
    }),
  })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/message_user/index.js